import React from "react";
import Navigation from "../components/Navigation/Navigation";

const Faq = () => {
	return (
		<>
			{" "}
			{/* Kopplar navigeringsmenyn */}
			<Navigation />
			<div className="main">
				<section className="wrapper">
					<h1>FAQ</h1>
					{/* Applikationens innehåll börjar - Frågor och svar */}
					<div className="wrapper_faq">
						<h3>Vanliga frågor och svar om katter</h3>
						<h4>Fråga: Hur kan det komma sig att katter ser så bra i mörker?</h4>
						<p>
							<strong>Svar: </strong>
							Kattens ögon är inte uppbyggda på samma sätt som människoögon, katter har ett
							speciellt kristallskikt i ögat som fungerar ungefär som en spegel. Katter ser
							ungefär 6 gånger bättre än oss människor i mörker.
						</p>
						<h4>Varför har katter morrhår, vad gör dom för nytta?</h4>
						<p>
							<strong>Svar: </strong>
							Morrhåret hjälper katten att navigera när det är mörkt. Det är med morrhåren
							katten känner först om den går emot någonting.
						</p>
						<h4>Är det nödvändigt att bada sin katt?</h4>
						<p>
							<strong>Svar: </strong>
							Om katten är korthårig sköter den vanligtvis sin pälshygien själv. Är det en
							katt med långhårig päls kan den behöva behöva lite hjälp bland, detta genom att
							bada katten och borsta pälsen för att minimera risken att pälsen tovar sig.
						</p>
						<h4>Vilka olika sjukdomar kan man vaccinera sin katt emot?</h4>
						<p>
							<strong>Svar: </strong>
							Det finns många olika sjukdomar som man kan vaccinera sin katt emot, dom
							vanligast använda vaccinen i Sverige idag är mot kattpest och kattsnuva.
							Vaccinationer sker alltid hos en veterinär, så blir du osäker fråga veterinären
							om råd.
						</p>
						<h4>
							Min familj har precis skaffat en kattunge och nu undrar vi hur länge vi kan
							lämna den ensam hemma?
						</h4>
						<p>
							<strong>Svar: </strong>
							En kattunge bör inte vara lämnad ensam mer än ungefär tre till fyra timmar. När
							katten sedan blir äldra kan den vara ensam en längre tid.
						</p>
						{/* Gif-bild */}
						<img
							src="./bilder/katt_svans.gif"
							alt="Katt som viftar på svansen"
							className="center"
						/>
					</div>
				</section>
			</div>
		</>
	);
};

export default Faq;
